import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useStore } from "@/model/store";

/** Asks for a name, creates the scenario and opens its page (same popover as the scenario bar's "+ Scenario"). */
export function NewScenarioPopover({ children }: { children: React.ReactNode }) {
	const [open, setOpen] = useState(false);
	const [name, setName] = useState("");
	const navigate = useNavigate();

	async function create() {
		const { addScenario, world } = useStore.getState();
		const id = await addScenario({ name: name.trim() || `Scenario ${world.scenarios.length + 1}` });
		if (!id) return;
		setName("");
		setOpen(false);
		navigate(`/scenario/${id}`);
	}

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>{children}</PopoverTrigger>
			<PopoverContent align="start" className="w-80 p-0">
				<form
					className="space-y-2 p-3"
					onSubmit={(e) => {
						e.preventDefault();
						void create();
					}}
				>
					<div className="text-xs font-medium text-muted-foreground">New scenario</div>
					<div className="flex gap-2">
						<Input
							autoFocus
							value={name}
							onChange={(e) => setName(e.target.value)}
							placeholder="e.g. Acme exits in 2027"
							className="h-8"
							aria-label="Scenario name"
						/>
						<Button size="sm" type="submit">
							Create
						</Button>
					</div>
					<p className="text-[11px] text-muted-foreground">Starts empty. Its page opens next, ready to set what it assumes.</p>
				</form>
			</PopoverContent>
		</Popover>
	);
}
